import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { X, ArrowRight, Sparkles } from "lucide-react";

/*
 * UpsellBanner — Suggestion contextuelle in-app (iter 8)
 * Affiche une bannière discrète en haut du dashboard, basée sur l'état du carnet.
 * L'utilisateur peut fermer la suggestion (masquée 30 jours).
 */
export default function UpsellBanner() {
  const [suggestion, setSuggestion] = useState(null);
  const [dismissing, setDismissing] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    let cancelled = false;
    api.get("/upsell/suggestion")
      .then((r) => { if (!cancelled) setSuggestion(r.data?.suggestion || null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    // Track impression une fois affichée
    if (suggestion?.service?.id) {
      api.post("/services/track", {
        service_key: suggestion.service.id,
        action: "impression",
        source: `trigger_${suggestion.trigger_key}`,
      }).catch(() => {});
    }
  }, [suggestion]);

  if (!suggestion) return null;

  const dismiss = async () => {
    setDismissing(true);
    try {
      await api.post("/upsell/dismiss", { trigger_key: suggestion.trigger_key });
    } catch (_e) { /* silent */ }
    setSuggestion(null);
  };

  const goToService = () => {
    api.post("/services/track", {
      service_key: suggestion.service.id,
      action: "click",
      source: `trigger_${suggestion.trigger_key}`,
    }).catch(() => {});
    nav("/services");
  };

  return (
    <div
      style={{
        background: "linear-gradient(90deg, rgba(21,41,79,0.98) 0%, rgba(29,58,114,0.98) 100%)",
        color: "#f3efe6",
        padding: "14px 20px",
        borderRadius: 6,
        display: "flex",
        alignItems: "center",
        gap: 16,
        flexWrap: "wrap",
        marginBottom: 20,
        border: "1px solid rgba(202,168,106,0.35)",
        position: "relative",
      }}
      data-testid="upsell-banner"
    >
      <Sparkles size={22} color="var(--auprea-gold)" style={{ flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 240 }}>
        <div style={{ fontSize: 11, letterSpacing: "0.15em", textTransform: "uppercase", color: "var(--auprea-gold)", fontWeight: 600, marginBottom: 3 }}>
          Suggestion personnalisée
        </div>
        <div style={{ fontSize: 14, lineHeight: 1.45, color: "#f3efe6" }}>
          <strong style={{ color: "#fff" }}>{suggestion.service.name} ({suggestion.service.price.toFixed(0)} €) —</strong>{" "}
          {suggestion.message}
        </div>
      </div>
      <button
        onClick={goToService}
        style={{
          background: "var(--auprea-gold)",
          color: "var(--auprea-navy)",
          padding: "9px 18px",
          fontSize: 14,
          fontWeight: 600,
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
        data-testid="btn-upsell-cta"
      >
        En savoir plus <ArrowRight size={14} style={{ display: "inline", marginLeft: 4 }} />
      </button>
      <button
        onClick={dismiss}
        disabled={dismissing}
        title="Masquer 30 jours"
        style={{ background: "transparent", border: "none", color: "rgba(243,239,230,0.7)", cursor: "pointer", padding: 4 }}
        data-testid="btn-upsell-dismiss"
      >
        <X size={18} />
      </button>
    </div>
  );
}
